// extracted by mini-css-extract-plugin
module.exports = {"link":"FeaturedCollections_link__PAZpX","description":"FeaturedCollections_description__jfF4y","image":"FeaturedCollections_image__8u_Jn"};